import React from 'react';

interface LegalContentProps {
  html: string;
}

const LegalContent: React.FC<LegalContentProps> = ({ html }) => (
  <div
    className="prose prose-blue max-w-none dark:prose-invert"
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

export default LegalContent;
